export default class PlanningDetailMultiEditItem {
  Ids: number[];
  NumberOfPlannedAssignments: number;
  ApplyTargetRates: boolean;
  TargetAssignmentRate: number[];
  TargetCompletionRate: number[];

  constructor(selectedItems, maxPlannedAssignments) {
    this.Ids = (selectedItems ?? []).map((item) => item.PlanningDetailId);
    this.NumberOfPlannedAssignments =
      typeof maxPlannedAssignments === 'undefined' || maxPlannedAssignments < 0 ? 0 : maxPlannedAssignments;
    this.ApplyTargetRates = false;
    this.TargetAssignmentRate = [30, 45, 25, 0];
    this.TargetCompletionRate = [20, 30, 30, 20];
  }
}
